import BaseHomeSectionListRouteStore from "./BaseHomeSectionListRouteStore";

class NakiMobileHandheldPinkHomeSectionListRouteStore extends BaseHomeSectionListRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHandheldPinkHomeSectionListRouteStore;
